import { User } from 'v2/models';

export function getUserFullName(user: User) {
  return `${user.first_name || ''} ${user.last_name || ''}`;
}
